<template>
  <label class="checkbox" :class="{ disabled }">
    <input class="checkbox__input" type="checkbox" :checked="value" :disabled="disabled" @change="onChange" />
    <span v-if="label || $slots.default" class="checkbox__label">
      <slot>{{ label }}</slot>
    </span>
  </label>
</template>

<script>
import './checkbox.scss'

export default {
  name: 'Checkbox',
  // v-model на нативном событии чекбокса, а не на input
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChange(event) {
      this.$emit('change', event.target.checked)
    }
  }
}
</script>
